import { render } from "./WrapWithInfo.vue?vue&type=template&id=31d0f200"
import script from "./WrapWithInfo.vue?vue&type=script&lang=js"
export * from "./WrapWithInfo.vue?vue&type=script&lang=js"

import "./WrapWithInfo.vue?vue&type=style&index=0&id=31d0f200&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__